import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';
import { TooltipModule } from '../tooltip/tooltip.module';
import { SearchComponent } from './components/search-bar/search/search.component';
import { SearchAutocompletionComponent } from './components/search-bar/search-autocompletion/search-autocompletion.component';
import { SearchItemComponent } from './components/search-bar/search-item/search-item.component';
import { NxI18nPipeModule } from '../nxI18nPipe/nxI18nPipe.module';
import { ResultFiltersComponent } from './components/result-filters/result-filters.component';
import { AggregateModule } from '../aggregate/aggregate.module';

@NgModule({
  declarations: [
    SearchComponent,
    SearchAutocompletionComponent,
    ResultFiltersComponent,
    SearchItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    MatProgressSpinnerModule,
    MatMenuModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    TooltipModule,
    ClickOutsideModule,
    TranslateModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatButtonToggleModule,
    MatButtonModule,
    PerfectScrollbarModule,
    MatAutocompleteModule,
    FormsModule,
    NxI18nPipeModule,
    AggregateModule,
    MatDatepickerModule
  ],
  exports: [
    SearchComponent,
    SearchAutocompletionComponent,
    SearchItemComponent,
    ResultFiltersComponent
  ]
})
export class SearchUiModule { }
